const EXACT_FACTORIAL_LIMIT = 18;

const exactFactorials: number[] = (() => {
  const arr = [1];
  for (let i = 1; i <= EXACT_FACTORIAL_LIMIT; i++) {
    arr.push(arr[i - 1]! * i);
  }
  return arr;
})();

export function factorial(n: number): number {
  if (n !== Math.floor(n) || n < 0) return NaN;
  if (n <= EXACT_FACTORIAL_LIMIT) return exactFactorials[n]!;
  return Math.sqrt(2 * Math.PI * n) * (n / Math.E) ** n;
}

export function nPr(n: number, r: number): number {
  if (r < 0 || r > n) return 0;
  let result = 1;
  for (let i = 0; i < r; i++) result *= n - i;
  return result;
}

export function nCr(n: number, r: number): number {
  if (r < 0 || r > n) return 0;
  if (r === 0 || r === n) return 1;
  const k = Math.min(r, n - r);
  let result = 1;
  for (let i = 0; i < k; i++) {
    result = (result * (n - i)) / (i + 1);
  }
  return Math.round(result);
}

export function pascalRow(n: number): number[] {
  const row: number[] = [1];
  for (let k = 1; k <= n; k++) {
    row.push((row[k - 1]! * (n - k + 1)) / k);
  }
  return row.map(Math.round);
}
